import { persistStore } from 'redux-persist'

import store from './'

let persistor = persistStore(store)

export default persistor
